var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDashboardFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 376,
    height: 190,
    viewBox: "0 0 376 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2694_97190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37259 5.37258 0 12 0H364C370.627 0 376 5.37258 376 12V190H0V12Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2694_97190)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2694_97190)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_2694_97190",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198 17.1953H230.4V24.4456H198V17.1953Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M198 17.1953H230.4V24.4456H198V17.1953Z",
    fill: "#354ACD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.4 24.4456V24.647H230.601V24.4456H230.4ZM230.4 17.1953H230.199V24.4456H230.4H230.601V17.1953H230.4ZM230.4 24.4456V24.2442H198V24.4456V24.647H230.4V24.4456Z",
    fill: "#DBDBDB",
    mask: "url(#path-5-inside-1_2694_97190)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-2_2694_97190",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.4 17.1953H262.8V24.4456H230.4V17.1953Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M230.4 17.1953H262.8V24.4456H230.4V17.1953Z",
    fill: "#354ACD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.8 24.4456V24.647H263.001V24.4456H262.8ZM262.8 17.1953H262.599V24.4456H262.8H263.001V17.1953H262.8ZM262.8 24.4456V24.2442H230.4V24.4456V24.647H262.8V24.4456Z",
    fill: "#DBDBDB",
    mask: "url(#path-7-inside-2_2694_97190)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-3_2694_97190",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.8 17.1953H295.2V24.4456H262.8V17.1953Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M262.8 17.1953H295.2V24.4456H262.8V17.1953Z",
    fill: "#354ACD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.2 24.4456V24.647H295.401V24.4456H295.2ZM295.2 17.1953H294.998V24.4456H295.2H295.401V17.1953H295.2ZM295.2 24.4456V24.2442H262.8V24.4456V24.647H295.2V24.4456Z",
    fill: "#DBDBDB",
    mask: "url(#path-9-inside-3_2694_97190)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-4_2694_97190",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.2 17.1953H327.6V24.4456H295.2V17.1953Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M295.2 17.1953H327.6V24.4456H295.2V17.1953Z",
    fill: "#354ACD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.6 24.4456V24.647H327.802V24.4456H327.6ZM327.6 17.1953H327.399V24.4456H327.6H327.802V17.1953H327.6ZM327.6 24.4456V24.2442H295.2V24.4456V24.647H327.6V24.4456Z",
    fill: "#DBDBDB",
    mask: "url(#path-11-inside-4_2694_97190)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-13-inside-5_2694_97190",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.6 17.1953H360V24.4456H327.6V17.1953Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M327.6 17.1953H360V24.4456H327.6V17.1953Z",
    fill: "#354ACD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 24.4456V24.647H360.201V24.4456H360ZM360 17.1953H359.799V24.4456H360H360.201V17.1953H360ZM360 24.4456V24.2442H327.6V24.4456V24.647H360V24.4456Z",
    fill: "#DBDBDB",
    mask: "url(#path-13-inside-5_2694_97190)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-15-inside-6_2694_97190",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198 25.6406H230.4V43.7302H198V25.6406Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M198 25.6406H230.4V43.7302H198V25.6406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.4 43.7302V43.9316H230.601V43.7302H230.4ZM230.4 25.6406H230.199V43.7302H230.4H230.601V25.6406H230.4ZM230.4 43.7302V43.5288H198V43.7302V43.9316H230.4V43.7302Z",
    fill: "#DBDBDB",
    mask: "url(#path-15-inside-6_2694_97190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.611 28.4603C199.611 27.793 200.152 27.252 200.82 27.252H227.581C228.248 27.252 228.789 27.793 228.789 28.4603V40.9108C228.789 41.5782 228.248 42.1192 227.581 42.1192H200.82C200.152 42.1192 199.611 41.5782 199.611 40.9108V28.4603Z",
    fill: "#8F9AE3"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-18-inside-7_2694_97190",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.4 25.6406H262.8V43.7302H230.4V25.6406Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M230.4 25.6406H262.8V43.7302H230.4V25.6406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.8 43.7302V43.9316H263.001V43.7302H262.8ZM262.8 25.6406H262.599V43.7302H262.8H263.001V25.6406H262.8ZM262.8 43.7302V43.5288H230.4V43.7302V43.9316H262.8V43.7302Z",
    fill: "#DBDBDB",
    mask: "url(#path-18-inside-7_2694_97190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.011 28.4603C232.011 27.793 232.552 27.252 233.22 27.252H259.98C260.648 27.252 261.189 27.793 261.189 28.4603V40.9108C261.189 41.5782 260.648 42.1192 259.98 42.1192H233.22C232.552 42.1192 232.011 41.5782 232.011 40.9108V28.4603Z",
    fill: "#1F36C7",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-21-inside-8_2694_97190",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.8 25.6406H295.2V43.7302H262.8V25.6406Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M262.8 25.6406H295.2V43.7302H262.8V25.6406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.2 43.7302V43.9316H295.401V43.7302H295.2ZM295.2 25.6406H294.998V43.7302H295.2H295.401V25.6406H295.2ZM295.2 43.7302V43.5288H262.8V43.7302V43.9316H295.2V43.7302Z",
    fill: "#DBDBDB",
    mask: "url(#path-21-inside-8_2694_97190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.411 28.4603C264.411 27.793 264.952 27.252 265.619 27.252H292.38C293.047 27.252 293.588 27.793 293.588 28.4603V40.9108C293.588 41.5782 293.047 42.1192 292.38 42.1192H265.619C264.952 42.1192 264.411 41.5782 264.411 40.9108V28.4603Z",
    fill: "#E9EBF9"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-24-inside-9_2694_97190",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.2 25.6406H327.6V43.7302H295.2V25.6406Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M295.2 25.6406H327.6V43.7302H295.2V25.6406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.6 43.7302V43.9316H327.802V43.7302H327.6ZM327.6 25.6406H327.399V43.7302H327.6H327.802V25.6406H327.6ZM327.6 43.7302V43.5288H295.2V43.7302V43.9316H327.6V43.7302Z",
    fill: "#DBDBDB",
    mask: "url(#path-24-inside-9_2694_97190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.812 28.4603C296.812 27.793 297.353 27.252 298.02 27.252H324.781C325.448 27.252 325.989 27.793 325.989 28.4603V40.9108C325.989 41.5782 325.448 42.1192 324.781 42.1192H298.02C297.353 42.1192 296.812 41.5782 296.812 40.9108V28.4603Z",
    fill: "#E9EBF9"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-27-inside-10_2694_97190",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.6 25.6406H360V43.7302H327.6V25.6406Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M327.6 25.6406H360V43.7302H327.6V25.6406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 43.7302V43.9316H360.201V43.7302H360ZM360 25.6406H359.799V43.7302H360H360.201V25.6406H360ZM360 43.7302V43.5288H327.6V43.7302V43.9316H360V43.7302Z",
    fill: "#DBDBDB",
    mask: "url(#path-27-inside-10_2694_97190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.211 28.4603C329.211 27.793 329.752 27.252 330.42 27.252H357.181C357.848 27.252 358.389 27.793 358.389 28.4603V40.9108C358.389 41.5782 357.848 42.1192 357.181 42.1192H330.42C329.752 42.1192 329.211 41.5782 329.211 40.9108V28.4603Z",
    fill: "#1F36C7",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-30-inside-11_2694_97190",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198 43.7305H230.4V61.8201H198V43.7305Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M198 43.7305H230.4V61.8201H198V43.7305Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.4 61.8201V62.0215H230.601V61.8201H230.4ZM230.4 43.7305H230.199V61.8201H230.4H230.601V43.7305H230.4ZM230.4 61.8201V61.6187H198V61.8201V62.0215H230.4V61.8201Z",
    fill: "#DBDBDB",
    mask: "url(#path-30-inside-11_2694_97190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.611 46.5502C199.611 45.8828 200.152 45.3418 200.82 45.3418H227.581C228.248 45.3418 228.789 45.8828 228.789 46.5502V59.0006C228.789 59.668 228.248 60.209 227.581 60.209H200.82C200.152 60.209 199.611 59.668 199.611 59.0006V46.5502Z",
    fill: "#1F36C7",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-33-inside-12_2694_97190",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.4 43.7305H262.8V61.8201H230.4V43.7305Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M230.4 43.7305H262.8V61.8201H230.4V43.7305Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.8 61.8201V62.0215H263.001V61.8201H262.8ZM262.8 43.7305H262.599V61.8201H262.8H263.001V43.7305H262.8ZM262.8 61.8201V61.6187H230.4V61.8201V62.0215H262.8V61.8201Z",
    fill: "#DBDBDB",
    mask: "url(#path-33-inside-12_2694_97190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.011 46.5502C232.011 45.8828 232.552 45.3418 233.22 45.3418H259.844C260.512 45.3418 261.053 45.8828 261.053 46.5502V59.0006C261.053 59.668 260.512 60.209 259.844 60.209H233.22C232.552 60.209 232.011 59.668 232.011 59.0006V46.5502Z",
    fill: "#8F9AE3"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-36-inside-13_2694_97190",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.8 43.7305H295.2V61.8201H262.8V43.7305Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M262.8 43.7305H295.2V61.8201H262.8V43.7305Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.2 61.8201V62.0215H295.401V61.8201H295.2ZM295.2 43.7305H294.998V61.8201H295.2H295.401V43.7305H295.2ZM295.2 61.8201V61.6187H262.8V61.8201V62.0215H295.2V61.8201Z",
    fill: "#DBDBDB",
    mask: "url(#path-36-inside-13_2694_97190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.411 46.5502C264.411 45.8828 264.952 45.3418 265.619 45.3418H292.244C292.911 45.3418 293.452 45.8828 293.452 46.5502V59.0006C293.452 59.668 292.911 60.209 292.244 60.209H265.619C264.952 60.209 264.411 59.668 264.411 59.0006V46.5502Z",
    fill: "#E9EBF9"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-39-inside-14_2694_97190",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.2 43.7305H327.6V61.8201H295.2V43.7305Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M295.2 43.7305H327.6V61.8201H295.2V43.7305Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.6 61.8201V62.0215H327.802V61.8201H327.6ZM327.6 43.7305H327.399V61.8201H327.6H327.802V43.7305H327.6ZM327.6 61.8201V61.6187H295.2V61.8201V62.0215H327.6V61.8201Z",
    fill: "#DBDBDB",
    mask: "url(#path-39-inside-14_2694_97190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.812 46.5502C296.812 45.8828 297.353 45.3418 298.02 45.3418H324.645C325.312 45.3418 325.853 45.8828 325.853 46.5502V59.0006C325.853 59.668 325.312 60.209 324.645 60.209H298.02C297.353 60.209 296.812 59.668 296.812 59.0006V46.5502Z",
    fill: "#8F9AE3",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-42-inside-15_2694_97190",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.6 43.7305H360V61.8201H327.6V43.7305Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M327.6 43.7305H360V61.8201H327.6V43.7305Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 61.8201V62.0215H360.201V61.8201H360ZM360 43.7305H359.799V61.8201H360H360.201V43.7305H360ZM360 61.8201V61.6187H327.6V61.8201V62.0215H360V61.8201Z",
    fill: "#DBDBDB",
    mask: "url(#path-42-inside-15_2694_97190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.211 46.5502C329.211 45.8828 329.752 45.3418 330.42 45.3418H357.045C357.712 45.3418 358.253 45.8828 358.253 46.5502V59.0006C358.253 59.668 357.712 60.209 357.045 60.209H330.42C329.752 60.209 329.211 59.668 329.211 59.0006V46.5502Z",
    fill: "#1F36C7",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-45-inside-16_2694_97190",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198 61.8203H230.4V79.9099H198V61.8203Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M198 61.8203H230.4V79.9099H198V61.8203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.4 79.9099V80.1113H230.601V79.9099H230.4ZM230.4 61.8203H230.199V79.9099H230.4H230.601V61.8203H230.4ZM230.4 79.9099V79.7085H198V79.9099V80.1113H230.4V79.9099Z",
    fill: "#DBDBDB",
    mask: "url(#path-45-inside-16_2694_97190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.611 64.64C199.611 63.9727 200.152 63.4316 200.82 63.4316H227.445C228.112 63.4316 228.653 63.9727 228.653 64.64V77.0905C228.653 77.7579 228.112 78.2989 227.445 78.2989H200.82C200.152 78.2989 199.611 77.7579 199.611 77.0905V64.64Z",
    fill: "#E9EBF9"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-48-inside-17_2694_97190",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.4 61.8203H262.8V79.9099H230.4V61.8203Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M230.4 61.8203H262.8V79.9099H230.4V61.8203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.8 79.9099V80.1113H263.001V79.9099H262.8ZM262.8 61.8203H262.599V79.9099H262.8H263.001V61.8203H262.8ZM262.8 79.9099V79.7085H230.4V79.9099V80.1113H262.8V79.9099Z",
    fill: "#DBDBDB",
    mask: "url(#path-48-inside-17_2694_97190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.011 64.64C232.011 63.9727 232.552 63.4316 233.22 63.4316H259.844C260.512 63.4316 261.053 63.9727 261.053 64.64V77.0905C261.053 77.7579 260.512 78.2989 259.844 78.2989H233.22C232.552 78.2989 232.011 77.7579 232.011 77.0905V64.64Z",
    fill: "#1F36C7",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-51-inside-18_2694_97190",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.8 61.8203H295.2V79.9099H262.8V61.8203Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M262.8 61.8203H295.2V79.9099H262.8V61.8203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.2 79.9099V80.1113H295.401V79.9099H295.2ZM295.2 61.8203H294.998V79.9099H295.2H295.401V61.8203H295.2ZM295.2 79.9099V79.7085H262.8V79.9099V80.1113H295.2V79.9099Z",
    fill: "#DBDBDB",
    mask: "url(#path-51-inside-18_2694_97190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.411 64.64C264.411 63.9727 264.952 63.4316 265.62 63.4316H292.244C292.912 63.4316 293.453 63.9727 293.453 64.64V77.0905C293.453 77.7579 292.912 78.2989 292.244 78.2989H265.62C264.952 78.2989 264.411 77.7579 264.411 77.0905V64.64Z",
    fill: "#8F9AE3",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-54-inside-19_2694_97190",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.2 61.8203H327.6V79.9099H295.2V61.8203Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M295.2 61.8203H327.6V79.9099H295.2V61.8203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.6 79.9099V80.1113H327.802V79.9099H327.6ZM327.6 61.8203H327.399V79.9099H327.6H327.802V61.8203H327.6ZM327.6 79.9099V79.7085H295.2V79.9099V80.1113H327.6V79.9099Z",
    fill: "#DBDBDB",
    mask: "url(#path-54-inside-19_2694_97190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.812 64.64C296.812 63.9727 297.353 63.4316 298.02 63.4316H324.645C325.312 63.4316 325.853 63.9727 325.853 64.64V77.0905C325.853 77.7579 325.312 78.2989 324.645 78.2989H298.02C297.353 78.2989 296.812 77.7579 296.812 77.0905V64.64Z",
    fill: "#E9EBF9"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-57-inside-20_2694_97190",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.6 61.8203H360V79.9099H327.6V61.8203Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M327.6 61.8203H360V79.9099H327.6V61.8203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 79.9099V80.1113H360.201V79.9099H360ZM360 61.8203H359.799V79.9099H360H360.201V61.8203H360ZM360 79.9099V79.7085H327.6V79.9099V80.1113H360V79.9099Z",
    fill: "#DBDBDB",
    mask: "url(#path-57-inside-20_2694_97190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.211 64.64C329.211 63.9727 329.752 63.4316 330.42 63.4316H357.045C357.712 63.4316 358.253 63.9727 358.253 64.64V77.0905C358.253 77.7579 357.712 78.2989 357.045 78.2989H330.42C329.752 78.2989 329.211 77.7579 329.211 77.0905V64.64Z",
    fill: "#1F36C7",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-60-inside-21_2694_97190",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198 79.9102H230.4V97.9998H198V79.9102Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M198 79.9102H230.4V97.9998H198V79.9102Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.4 97.9998V98.2012H230.601V97.9998H230.4ZM230.4 79.9102H230.199V97.9998H230.4H230.601V79.9102H230.4ZM230.4 97.9998V97.7984H198V97.9998V98.2012H230.4V97.9998Z",
    fill: "#DBDBDB",
    mask: "url(#path-60-inside-21_2694_97190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.611 82.7299C199.611 82.0625 200.152 81.5215 200.82 81.5215H227.445C228.112 81.5215 228.653 82.0625 228.653 82.7299V95.1803C228.653 95.8477 228.112 96.3887 227.445 96.3887H200.82C200.152 96.3887 199.611 95.8477 199.611 95.1803V82.7299Z",
    fill: "#1F36C7",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-63-inside-22_2694_97190",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.4 79.9102H262.8V97.9998H230.4V79.9102Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M230.4 79.9102H262.8V97.9998H230.4V79.9102Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.8 97.9998V98.2012H263.001V97.9998H262.8ZM262.8 79.9102H262.599V97.9998H262.8H263.001V79.9102H262.8ZM262.8 97.9998V97.7984H230.4V97.9998V98.2012H262.8V97.9998Z",
    fill: "#DBDBDB",
    mask: "url(#path-63-inside-22_2694_97190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.011 82.7299C232.011 82.0625 232.552 81.5215 233.22 81.5215H259.844C260.512 81.5215 261.053 82.0625 261.053 82.7299V95.1803C261.053 95.8477 260.512 96.3887 259.844 96.3887H233.22C232.552 96.3887 232.011 95.8477 232.011 95.1803V82.7299Z",
    fill: "#8F9AE3"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-66-inside-23_2694_97190",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.8 79.9102H295.2V97.9998H262.8V79.9102Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M262.8 79.9102H295.2V97.9998H262.8V79.9102Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.2 97.9998V98.2012H295.401V97.9998H295.2ZM295.2 79.9102H294.998V97.9998H295.2H295.401V79.9102H295.2ZM295.2 97.9998V97.7984H262.8V97.9998V98.2012H295.2V97.9998Z",
    fill: "#DBDBDB",
    mask: "url(#path-66-inside-23_2694_97190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.411 82.7299C264.411 82.0625 264.952 81.5215 265.62 81.5215H292.244C292.912 81.5215 293.453 82.0625 293.453 82.7299V95.1803C293.453 95.8477 292.912 96.3887 292.244 96.3887H265.62C264.952 96.3887 264.411 95.8477 264.411 95.1803V82.7299Z",
    fill: "#E9EBF9"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-69-inside-24_2694_97190",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.2 79.9102H327.6V97.9998H295.2V79.9102Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M295.2 79.9102H327.6V97.9998H295.2V79.9102Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.6 97.9998V98.2012H327.802V97.9998H327.6ZM327.6 79.9102H327.399V97.9998H327.6H327.802V79.9102H327.6ZM327.6 97.9998V97.7984H295.2V97.9998V98.2012H327.6V97.9998Z",
    fill: "#DBDBDB",
    mask: "url(#path-69-inside-24_2694_97190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.812 82.7299C296.812 82.0625 297.353 81.5215 298.02 81.5215H324.645C325.312 81.5215 325.853 82.0625 325.853 82.7299V95.1803C325.853 95.8477 325.312 96.3887 324.645 96.3887H298.02C297.353 96.3887 296.812 95.8477 296.812 95.1803V82.7299Z",
    fill: "#E9EBF9"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-72-inside-25_2694_97190",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.6 79.9102H360V97.9998H327.6V79.9102Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M327.6 79.9102H360V97.9998H327.6V79.9102Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 97.9998V98.2012H360.201V97.9998H360ZM360 79.9102H359.799V97.9998H360H360.201V79.9102H360ZM360 97.9998V97.7984H327.6V97.9998V98.2012H360V97.9998Z",
    fill: "#DBDBDB",
    mask: "url(#path-72-inside-25_2694_97190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.211 82.7299C329.211 82.0625 329.752 81.5215 330.42 81.5215H357.045C357.712 81.5215 358.253 82.0625 358.253 82.7299V95.1803C358.253 95.8477 357.712 96.3887 357.045 96.3887H330.42C329.752 96.3887 329.211 95.8477 329.211 95.1803V82.7299Z",
    fill: "#E9EBF9"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 197.899,
    y: 15.8993,
    width: 162.201,
    height: 82.2014,
    rx: 1.71188,
    stroke: "#DBDBDB",
    strokeWidth: 0.201398
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2694_97190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.552 200L352.552 118",
    stroke: "#D9E1E7",
    strokeWidth: 0.186206
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.6 200L327.6 118",
    stroke: "#D9E1E7",
    strokeWidth: 0.186206
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.648 200L302.648 118",
    stroke: "#D9E1E7",
    strokeWidth: 0.186206
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.697 200L277.697 118",
    stroke: "#D9E1E7",
    strokeWidth: 0.186206
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.746 200L252.746 118",
    stroke: "#D9E1E7",
    strokeWidth: 0.186206
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.794 200L227.794 118",
    stroke: "#D9E1E7",
    strokeWidth: 0.186206
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.842 200L202.842 118",
    stroke: "#D9E1E7",
    strokeWidth: 0.186206
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198 126H346.592C348.238 126 349.571 127.334 349.571 128.979V131.959C349.571 133.604 348.238 134.938 346.592 134.938H198V126Z",
    fill: "#6272D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198 140.303H346.592C348.238 140.303 349.571 141.637 349.571 143.282V146.261C349.571 147.907 348.238 149.241 346.592 149.241H198V140.303Z",
    fill: "#D2D7F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198 154.607H276.579C278.224 154.607 279.558 155.941 279.558 157.587V160.566C279.558 162.211 278.224 163.545 276.579 163.545H198V154.607Z",
    fill: "#8F9AE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198 168.91H209.545C211.19 168.91 212.524 170.244 212.524 171.889V174.869C212.524 176.514 211.19 177.848 209.545 177.848H198V168.91Z",
    fill: "#6272D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198 183.213H276.579C278.224 183.213 279.558 184.547 279.558 186.192V189.171C279.558 190.817 278.224 192.151 276.579 192.151H198V183.213Z",
    fill: "#D2D7F4"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_2694_97190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.2813 195.75C25.5736 195.75 24.9988 195.176 25.0114 194.469C25.1985 183.994 27.6776 173.681 32.2806 164.258C37.0712 154.451 44.036 145.866 52.645 139.157C61.2539 132.447 71.28 127.791 81.9602 125.541C92.2222 123.379 102.828 123.494 113.032 125.872C113.721 126.032 114.137 126.73 113.964 127.416L107.596 152.694C107.423 153.38 106.727 153.794 106.036 153.642C100.058 152.323 93.8619 152.292 87.8617 153.556C81.4432 154.908 75.4178 157.707 70.244 161.739C65.0703 165.771 60.8846 170.93 58.0056 176.824C55.3142 182.334 53.831 188.349 53.6491 194.469C53.6281 195.176 53.0565 195.75 52.3488 195.75H26.2813Z",
    fill: "#8F9AE3",
    stroke: "white",
    strokeWidth: 0.640625,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.233 127.484C114.409 126.799 115.107 126.385 115.79 126.572C131.499 130.896 145.27 140.438 154.835 153.629C155.25 154.201 155.107 155.001 154.527 155.406L133.205 170.295C132.625 170.7 131.828 170.557 131.405 169.989C125.764 162.4 117.786 156.871 108.7 154.255C108.02 154.059 107.606 153.363 107.781 152.677L114.233 127.484Z",
    fill: "#D2D7F4",
    stroke: "white",
    strokeWidth: 0.640625,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.672 155.614C155.253 155.211 156.053 155.355 156.445 155.944C164.116 167.446 168.299 180.921 168.493 194.745C168.503 195.453 167.926 196.024 167.218 196.022L141.256 195.922C140.549 195.919 139.979 195.343 139.961 194.635C139.755 186.655 137.343 178.887 132.993 172.194C132.608 171.601 132.751 170.804 133.332 170.401L154.672 155.614Z",
    fill: "#6272D8",
    stroke: "white",
    strokeWidth: 0.640625,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_2694_97190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178 23.7773L17 23.7773",
    stroke: "#D9E1E7",
    strokeWidth: 0.194429
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178 49.8301L17 49.8301",
    stroke: "#D9E1E7",
    strokeWidth: 0.194429
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178 75.8848L17 75.8848",
    stroke: "#D9E1E7",
    strokeWidth: 0.194429
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 98L21 25.4797C21 23.7617 22.3928 22.3689 24.1109 22.3689L27.2217 22.3689C28.9398 22.3689 30.3326 23.7617 30.3326 25.4797L30.3326 98L21 98Z",
    fill: "#8F9AE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9258 98L36.9258 48.8227C36.9258 47.1046 38.3186 45.7118 40.0366 45.7118L43.1475 45.7118C44.8656 45.7118 46.2584 47.1046 46.2584 48.8227L46.2584 98L36.9258 98Z",
    fill: "#6272D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8511 98L52.8511 58.1598C52.8511 56.4418 54.2439 55.049 55.9619 55.049L59.0728 55.049C60.7909 55.049 62.1837 56.4418 62.1837 58.1598L62.1837 98L52.8511 98Z",
    fill: "#C7CDF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7769 98L68.7769 39.5319C68.7769 37.8138 70.1696 36.4211 71.8877 36.4211L74.9986 36.4211C76.7167 36.4211 78.1094 37.8138 78.1094 39.5319L78.1094 98L68.7769 98Z",
    fill: "#D2D7F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7021 98L84.7021 52.5575C84.7021 50.8395 86.0949 49.4467 87.813 49.4467L90.9239 49.4467C92.642 49.4467 94.0347 50.8395 94.0347 52.5575L94.0347 98L84.7021 98Z",
    fill: "#6272D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.628 98L100.628 85.9454C100.628 84.2273 102.021 82.8345 103.739 82.8345L106.85 82.8345C108.568 82.8345 109.961 84.2273 109.961 85.9454L109.961 98L100.628 98Z",
    fill: "#C7CDF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.554 98L116.554 85.9454C116.554 84.2273 117.946 82.8345 119.665 82.8345L122.775 82.8345C124.494 82.8345 125.886 84.2273 125.886 85.9454L125.886 98L116.554 98Z",
    fill: "#6272D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.479 98L132.479 67.9639C132.479 66.2458 133.872 64.853 135.59 64.853L138.701 64.853C140.419 64.853 141.812 66.2458 141.812 67.9639L141.812 98L132.479 98Z",
    fill: "#8F9AE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.405 98L148.405 48.8227C148.405 47.1046 149.798 45.7118 151.516 45.7118L154.627 45.7118C156.345 45.7118 157.737 47.1046 157.737 48.8227L157.737 98L148.405 98Z",
    fill: "#8F9AE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.33 98L164.33 25.4797C164.33 23.7617 165.723 22.3689 167.441 22.3689L170.552 22.3689C172.27 22.3689 173.663 23.7617 173.663 25.4797L173.663 98L164.33 98Z",
    fill: "#6272D8"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2694_97190"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37259 5.37258 0 12 0H364C370.627 0 376 5.37258 376 12V190H0V12Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2694_97190"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198 16.8056C198 16.3607 198.361 16 198.806 16H359.194C359.639 16 360 16.3607 360 16.8056V97.1944C360 97.6393 359.639 98 359.194 98H198.806C198.361 98 198 97.6393 198 97.1944V16.8056Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2694_97190"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 16,
    width: 162,
    height: 82,
    rx: 1.61119,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2694_97190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 162,
    height: 82,
    fill: "white",
    transform: "translate(198 118)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_2694_97190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 162,
    height: 82,
    fill: "white",
    transform: "translate(16 118)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_2694_97190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 162,
    fill: "white",
    transform: "translate(16 98) rotate(-90)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDashboardFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dashboard-filled.e051b30337f4076bf81f65d12c539822.svg";